
import { fieldTypeReducer } from "../reducer/FieldTypeReducer";

export const reducer = fieldTypeReducer;